// @ts-strict-ignore
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LMSecurityUtilService } from '@app/utils/lm-security-util.service';

@Pipe({
  name: 'escape',
  standalone: false
})
export class LMEscapePipe implements PipeTransform {
  constructor(
    protected _sanitizer: DomSanitizer,
    protected _securityUtil: LMSecurityUtilService
  ) {
  }

  public transform(unsafe: string): string {
    return this._securityUtil.escape(unsafe);
  }
}
